import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-3 text-muted"
}
const _hoisted_2 = { class: "item d-flex align-items-center" }
const _hoisted_3 = { class: "pr-3" }
const _hoisted_4 = { class: "flex-fill" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_7 = { class: "ml-2" }

import {computed, onMounted} from "vue";
import {__} from "~/ts/library/Translate";
import DateHelper from "../../../ts/library/Date";
import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import CoreUiChatClientAvatar from "~/core-ui/vue/chat/CoreUiChatClientAvatar.vue";
import CoreUiHtmlify from "~/core-ui/vue/ui/CoreUiHtmlify.vue";

import OperatorApplicationMessageStatusLogOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageStatusLogOpenApiModel;

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CoreUiChatHistoryMessageReactionHistoryPopover"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    operators: {},
    showOperatorLogins: { type: Boolean },
    client: {}
  },
  emits: ["reposition", "close"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit


let operators = computed(() => ObjectHelper.dictionaryFromArray(props.operators, "login"));

function getOperator(item: OperatorApplicationMessageStatusLogOpenApiModel) {
    return operators.value[item.operatorLogin];
}

function getDescr(item: OperatorApplicationApi.MessageReactionHistoryOpenApiModel) {
    if (!item.operatorLogin) {
        return __("Клиент");
    } else {
        let operatorDescr = item.operatorLogin;
        let operator = getOperator(item);
        if (operator) {
            operatorDescr = operator.fio;
            if (props.showOperatorLogins) {
                operatorDescr += ` (${operator.login})`;
            }
        }

        return operatorDescr;
    }
}

onMounted(() => {
    setTimeout(() => {
        emits('reposition');
    }, 1)
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!__props.message.reactionsHistory?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(__)("Реакции не найдены")), 1))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(__props.message.reactionsHistory, (item) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (item.operatorLogin)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (getOperator(item))
                      ? (_openBlock(), _createBlock(CoreUiOperatorAvatar, {
                          key: 0,
                          operator: getOperator(item)
                        }, null, 8, ["operator"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (__props.client)
                  ? (_openBlock(), _createBlock(CoreUiChatClientAvatar, {
                      key: 1,
                      client: __props.client
                    }, null, 8, ["client"]))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(getDescr(item)), 1),
              _createElementVNode("div", null, [
                (item.emoji)
                  ? (_openBlock(), _createBlock(CoreUiHtmlify, {
                      key: 0,
                      class: "emoji",
                      emoji: "",
                      value: item.emoji
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(__)("Удалил реакцию")), 1)),
                _createElementVNode("span", _hoisted_7, _toDisplayString((new (_unref(DateHelper))(item.timestamp)).toLocaleDateTimeString(true)), 1)
              ])
            ])
          ]))
        }), 256))
  ]))
}
}

})